import { useMemo } from 'react';
import { getDefaultColorSet } from '../../../../../../components/ColorPicker';
import { useTheme } from '../../../../../../themes';

/** The actor colour picker's swatches: the shared ColorPicker's default set. */
export const useActorPickerColors = (): string[] => {
  const theme = useTheme();
  return useMemo(() => getDefaultColorSet(theme.custom.colors), [theme]);
};
